import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { F33CrudCreate } from "../models/f33.model";
import { SHARED_LIB_CONFIG, SharedLibConfig } from "../config/lib-config";

@Injectable({
    providedIn: 'root',
})
export class Feeder33Service {
    private pathApi: string;
    constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
        this.pathApi = this.config.pathApi + 'feeder33/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    getAllForSelect(utilityId: number | null = null): Observable<any> {
        if (utilityId) {
            return this.http.get(`${this.pathApi}getAllForSelect/${utilityId}`, { observe: 'response' });
        }
        else {
            return this.http.get(`${this.pathApi}getAllForSelect`, { observe: 'response' });
        }
    }

    getAll(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}getAll`, dataIn, { observe: 'response' });
    }

    save(f33: F33CrudCreate): Observable<any> {
        return this.http.post(`${this.pathApi}save`, f33, { observe: 'response' });
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${this.pathApi}delete/${id}`, { observe: 'response' });
    }

    downloadFile(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}downloadFile`, dataIn);
    }
}